import React from 'react'
import { PaymentRequestButtonElement } from '@stripe/react-stripe-js'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'

const ANALYTICS_EVENT = {
  SHOW_STRIPE_PAYMENT_BUTTON: 'SHOW_STRIPE_PAYMENT_BUTTON'
}
const StripePaymentButton = React.memo(function StripePaymentButton ({ paymentRequest }) {
  React.useEffect(() => {
    logEventAnalyticsUtil(ANALYTICS_EVENT.SHOW_STRIPE_PAYMENT_BUTTON)
  }, [])

  return (
    <PaymentRequestButtonElement
      className='PaymentRequestButton'
      options={{ paymentRequest }}
      style={{
        paymentRequestButton: {
          theme: 'light',
          height: '3.55em',
          type: 'buy'
        }
      }}
    />
  )
})

export default StripePaymentButton
